<template>
  <b-row v-if="loaded && alerts !== false">
    <b-col v-for="(alertGroup, id) in alerts" :key="id" lg="6" md="12">
      <b-card class="card-custom mb-5 min-h-350px max-h-350px" no-body>
        <div class="card-header border-0">
          <h3 class="card-title font-weight-bolder text-dark">
            {{ alertGroup[0].executeAction.title }}
          </h3>
        </div>
        <div class="card-body p-0 mb-3" :style="{ overflow: 'auto' }">
          <!--begin::Responsive container-->
          <div class="table-responsive">
            <!--begin::Items-->
            <div
              class="list list-hover"
              data-inbox="list"
              v-for="alert in alertGroup"
              :key="alert.stakeholderId"
            >
              <!--begin::Item-->
              <div
                class="d-flex align-items-start list-item card-spacer-x py-4"
                data-inbox="message"
              >
                <!--begin::Info-->
                <div class="flex-grow-1 mt-1 mr-2" data-toggle="view">
                  <!--begin::Title-->
                  <div
                    class="font-weight-bolder mr-2 text-left"
                    v-html="alert.executeAction.description"
                  />
                  <!--end::Title-->
                  <!--begin::Labels-->
                  <div class="mt-2">
                    <b-button
                      @click="
                        $router.push({
                          name: 'UserDetail',
                          params: { id: alert.stakeholderId }
                        })
                      "
                      class="label label-light-primary font-weight-bold label-inline"
                      >{{ $t("messages.tables.seeDetail") }}</b-button
                    >
                  </div>
                  <!--end::Labels-->
                </div>
                <!--end::Info-->
              </div>
              <!--end::Item-->
            </div>
            <!--end::Items-->
          </div>
          <!--end::Responsive container-->
        </div>
      </b-card>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col>
      <empty-card type="department.alerts" />
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import _ from "lodash";

import { getAlerts } from "@/api/traits.api";

import EmptyCard from "@/components/EmptyCard.component";

export default {
  name: "Alerts",
  props: {
    stakeholderId: {
      type: String,
      required: true
    }
  },
  components: {
    EmptyCard
  },
  data() {
    return {
      alerts: false,
      loaded: false
    };
  },
  computed: {
    ...mapGetters("Constants", ["getConstant"])
  },
  mounted() {
    var alertsData = {
      surveyTypes: [this.getConstant("SURVEY_KYMATIO_GRI_GLOBAL")],
      groupDimensions: [
        this.getConstant("DIMENSION_GROUP_INSIDER"),
        this.getConstant("DIMENSION_GROUP_RISK"),
        this.getConstant("DIMENSION_GROUP_DESIRABILITY"),
        this.getConstant("DIMENSION_GROUP_LIAR")
      ],
      hierarchyTypes: [this.getConstant("HIERARCHYTYPE_DEPARTMENT_EMPLOYEE")],
      actionTypes: [this.getConstant("ACTIONS_TYPE_ALERT")]
    };

    axios.all([getAlerts(this.stakeholderId, alertsData)]).then(
      axios.spread(cyberProfileResp => {
        if (cyberProfileResp.data.records.length > 0) {
          this.alerts = _.groupBy(
            cyberProfileResp.data.records,
            alert => alert.dimensionGroupId
          );
        }
        this.loaded = true;
      })
    );
  }
};
</script>
